import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme';

import {
  CmsTileModalLeftContentContainer,
  CmsTileModalLeftContentImageContainer,
} from './CmsTileModalLeftContent.styled';

type Props = {
  imageData: ApiFilestackImageData;
  caption: string | undefined;
};

export function CmsTileModalLeftContent({ imageData, caption }: Props) {
  return (
    <CmsTileModalLeftContentContainer>
      <CmsTileModalLeftContentImageContainer>
        <FilestackImage
          data={imageData}
          objectFit="cover"
          expandSize
          width={1200}
          height={1200}
          aspectRatio={{ width: 1, height: 1 }}
        />
      </CmsTileModalLeftContentImageContainer>

      {caption && (
        <BodySmall color={colors.lightContentGrey} mt="8px" as="figcaption">
          {caption}
        </BodySmall>
      )}
    </CmsTileModalLeftContentContainer>
  );
}
